import http from './http'

export default {

    all(){
        return http.get(`productos`)
    },

    get(clave_producto){
        return http.get(`productos/${clave_producto}`)
    },


    solicitudes(clave_producto){
        return http.get(`productos/${clave_producto}/solicitudes`)
    },

    solicitud(clave_producto,solicitud_id){
        return http.get(`productos/${clave_producto}/solicitudes/${solicitud_id}`)
    }


    ,solicitud_estatus(clave_producto,solicitud_id, payload){
        return http.put(`productos/${clave_producto}/solicitudes/${solicitud_id}/estatus`, payload)
    }

    ,actualiza_estatus_archivo(clave_producto, solicitud_id, archivo_id, payload){
        return http.put(`productos/${clave_producto}/solicitudes/${solicitud_id}/archivos/${archivo_id}/estatus`, payload)
    }

    ,descargar(clave_producto, solicitud_id, archivo_id){
        return http.get(`productos/${clave_producto}/solicitudes/${solicitud_id}/archivos/${archivo_id}/descargar`, {responseType: 'blob'})
    }

}